// Ubicación en el repo: src/components/CompareExamsModal.jsx
// "Comparar seleccionadas" — mismo contenido que openCompareModal() del
// prototipo (línea ~1725): ordena por fecha (más antigua = línea sólida),
// avisa si son de pacientes distintos.
import { formatPatientName, formatDate } from '../lib/format';
import ComparisonAudiogramSVG from './ComparisonAudiogramSVG';

export default function CompareExamsModal({ examA, examB, onClose }) {
  const samePatient = examA.patient_id === examB.patient_id;
  const [older, newer] = examA.date <= examB.date ? [examA, examB] : [examB, examA];

  return (
    <div className="modal-overlay">
      <div className="modal-card modal-card--wide">
        <h2>Comparar audiometrías</h2>

        {!samePatient && (
          <p className="field-hint field-hint--error">⚠ Estás comparando exámenes de pacientes distintos.</p>
        )}

        <p className="field-hint" style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          <span>
            <strong>Color tenue (atrás):</strong> {formatPatientName(older.patients)} · {formatDate(older.date)}
          </span>
          <span>
            <strong>Color pleno (adelante):</strong> {formatPatientName(newer.patients)} · {formatDate(newer.date)}
          </span>
        </p>

        <div className="audiogram-wrap">
          <ComparisonAudiogramSVG older={older} newer={newer} />
          <div className="legend">
            <span>
              <span className="dot" style={{ background: '#C4453C' }} />
              OD
            </span>
            <span>
              <span className="dot" style={{ background: '#2563A6' }} />
              OI
            </span>
          </div>
        </div>

        <p className="field-hint" style={{ marginTop: 10 }}>
          Se comparan solo los umbrales de vía aérea (○/×), para que la lectura de la evolución sea más clara.
        </p>

        <div className="modal-actions">
          <button type="button" className="button-secondary" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}
